import { v4 as uuidv4 } from "uuid";
import type { RootBlock } from "@circle-react-shared/BuilderUI/DataModel.types";

export const defaultData: RootBlock = {
  id: uuidv4(),
  type: "root",
  meta: {},
  props: {
    children: {
      prop: "children",
      type: "children",
      value: [],
      meta: {
        name: "Children",
        nameI18n: "builder_ui.prop_type.children",
      },
    },
  },
};
